$ = require("jquery");

$(function(){

  var array = ['sakura','forest'];

  $.each(array, function(index, value){

    var test = '.js-ft-Toggle__' + value;
    var thum = '.js-ft-Toggle__' + value + ' img';
    var image = '.js-ft-Image__' + value;

    $(thum).on('click', function(){
      $(test + ' li img').removeClass('is-active');
      $(this).addClass('is-active');

      var $path = $(this).attr('src').replace('thum', 'pic');

      $(image).attr('src', $path);
    });
  });
});

